// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hJ3h","buttons":"styles_buttons__1lvQb"};